/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit } from "@angular/core";
import { setActualDimensions } from "../../liveshop/utils/helpers";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-enable-cookies",
  templateUrl: "./enable-cookies.component.html",
  styleUrls: ["./enable-cookies.component.scss"],
})
export class EnableCookiesComponent implements OnInit {
  windowHeight: any;
  windowWidth: any;
  constructor(public dialogRef: MatDialogRef<EnableCookiesComponent>) {}

  ngOnInit(): void {
    this.setDimensions();
  }

  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
  }
  isMobileDevice() {
    return this.windowWidth <= 6;
  }
  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 9;
  }
}
